import axios from "axios";
import Vue from "vue";
import { getValidateUserApiUrl } from '@/utils/config';

export default {
  checkUsername(userId) {
    const url = `${getValidateUserApiUrl()}?user_id=${userId}`;
    return axios.get(url, {
      headers: {
        ...Vue.prototype.$OAuth.buildHttpHeader({
          Accept: "application/json",
          "Content-Type": "application/json; charset=UTF-8",
          "adfs":"true"
        }),
      }
    })
      .then((response) => {
        return response.data.length !== 0;
      })
      .catch(err => {
        console.error(err);
        return false;
      })
  },
}
